import {
    FETCH_NOTIFICATION_COUNTER_BEGIN,
    FETCH_NOTIFICATION_COUNTER_FAILURE,
    FETCH_NOTIFICATION_COUNTER_SUCCESS
} from "../action/notificationCounterAction";

const initialState = {
    notificationCount: 0,
    loading: false,
    error: null
};

export default function NotificationCounterReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_NOTIFICATION_COUNTER_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_NOTIFICATION_COUNTER_SUCCESS:
            return {
                ...state,
                loading: false,
                notificationCount: action.payload.notificationCounter,
            };

        case FETCH_NOTIFICATION_COUNTER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                notificationCount: 0,
            };
        default:
            return state;
    }
}
